import { aC as a, aM as n } from "./StickyHeaderSkeleton-dac046bb.mjs";
import { v as o, A as e } from "./Header-dd25ab18.mjs";
function u(r) {
  const {
    lang: s
  } = a();
  return o({
    queryKey: [e.CLIENT_V1_COURSE_CATEGORY, {
      lang: s
    }, "GNB_COURSE_CATEGORIES"],
    url: n(e.CLIENT_V1_COURSE_CATEGORY),
    options: {
      ...r,
      suspense: !1,
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      useErrorBoundary: !1
    }
  });
}
export {
  u
};
